import { CLEAR_INVOICE_DATA, UPDATE_INVOICE_DATA } from './action'

const initialState = {
  isModalOpen: false,
  data: null
}

export const invoiceReducers = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_INVOICE_DATA:
      return initialState
    case UPDATE_INVOICE_DATA:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}
